import { Typography, Image } from "antd";
import CustomButton from "../../../components/CustomButton/Button";
import { formatCurrency } from "../../../helpers/helpers";
import EyeIcon from "../../../assets/icons/eye-icon.svg";

const { Text } = Typography;

export const getWalletColumns = ({ tabIndex, onView }) => {
    switch (tabIndex) {
        // 🔹 1️⃣ User Wallets
        case 1:
            return [
                {
                    title: "Organization ID",
                    dataIndex: "orgId",
                    key: "orgId",
                    width: 200,
                },
                {
                    title: "Organization Name",
                    dataIndex: "orgName",
                    key: "orgName",
                    width: 200,
                },
                {
                    title: "User Name",
                    dataIndex: "contactName",
                    key: "contactName",
                },
                {
                    title: "User Role",
                    dataIndex: "isInvestor",
                    key: "userRole",
                    render: (isInvestor) => (isInvestor ? "Investor" : "Business"),
                },
                {
                    title: "VA Account ID",
                    dataIndex: "vaAccountId",
                    key: "vaAccountId",
                    width: 200,
                },
                {
                    title: "Wallet Balance",
                    dataIndex: "balance",
                    key: "balance",
                    width: 200,
                    render: (val) => <Text>{formatCurrency(val)}</Text>,
                },
                {
                    title: "User Status",
                    dataIndex: "statusName",
                    key: "statusName",
                    render: (status) => (
                        <Text type={status === "Active" ? "success" : "secondary"}>
                            {status || "-"}
                        </Text>
                    ),
                },
                {
                    title: "Action",
                    key: "action",
                    fixed: "right",
                    render: (_, record) => (
                        <CustomButton
                            type="text"
                            icon={<Image src={EyeIcon} alt="View" preview={false} />}
                            onClick={() => onView(record)}
                        />
                    ),
                },
            ];

        // 🔹 2️⃣ Business Enterprise Wallets
        case 2:
            return [
                {
                    title: "Business Enterprise ID",
                    dataIndex: "busEntId",
                    key: "busEntId",
                    width: 250,
                },
                {
                    title: "Business Name",
                    dataIndex: "orgName",
                    key: "orgName",
                },
                {
                    title: "Enterprise Name",
                    dataIndex: "entName",
                    key: "entName",
                },
                {
                    title: "VA Account ID",
                    dataIndex: "vaAccountId",
                    key: "vaAccountId",
                    width: 250,
                },
                {
                    title: "Wallet Balance",
                    dataIndex: "balance",
                    key: "balance",
                    width: 200,
                    render: (val) => <Text>{formatCurrency(val)}</Text>,
                },
                {
                    title: "Business Enterprise Status",
                    dataIndex: "statusName",
                    key: "statusName",
                    width: 250,
                    render: (status) => (
                        <Text type={status === "Active" ? "success" : "secondary"}>
                            {status || "-"}
                        </Text>
                    ),
                },
                {
                    title: "Action",
                    key: "action",
                    fixed: "right",
                    render: (_, record) => (
                        <CustomButton
                            type="text"
                            icon={<Image src={EyeIcon} alt="View" preview={false} />}
                            onClick={() => onView(record)}
                        />
                    ),
                },
            ];

        // 🔹 3️⃣ Pooling Wallets
        case 3:
            return [
                {
                    title: "Organization ID",
                    dataIndex: "orgId",
                    key: "orgId",
                },
                {
                    title: "Organization Name",
                    dataIndex: "orgName",
                    key: "orgName",
                },
                // {
                //     title: "User Role",
                //     dataIndex: "isInvestor",
                //     key: "userRole",
                //     render: (isInvestor) => (isInvestor ? "Investor" : "Business"),
                // },
                {
                    title: "VA Account ID",
                    dataIndex: "vaAccountId",
                    key: "vaAccountId",
                },
                {
                    title: "Wallet Balance",
                    dataIndex: "balance",
                    key: "balance",
                    render: (val) => <Text>{formatCurrency(val)}</Text>,
                },
                // {
                //     title: "User Status",
                //     dataIndex: "statusName",
                //     key: "statusName",
                //     render: (status) => (
                //         <Text type={status === "Active" ? "success" : "secondary"}>
                //             {status || "-"}
                //         </Text>
                //     ),
                // },
                {
                    title: "Action",
                    key: "action",
                    fixed: "right",
                    render: (_, record) => (
                        <CustomButton
                            type="text"
                            icon={<Image src={EyeIcon} alt="View" preview={false} />}
                            onClick={() => onView(record)}
                        />
                    ),
                },
            ];

        // 🔹 4️⃣ Karncy Wallets
        case 4:
            return [
                {
                    title: "Organization ID",
                    dataIndex: "orgId",
                    key: "orgId",
                },
                {
                    title: "Organization Name",
                    dataIndex: "orgName",
                    key: "orgName",
                },
                // {
                //     title: "User Role",
                //     dataIndex: "isInvestor",
                //     key: "userRole",
                //     render: (isInvestor) => (isInvestor ? "Investor" : "Business"),
                // },
                {
                    title: "VA Account ID",
                    dataIndex: "vaAccountId",
                    key: "vaAccountId",
                },
                {
                    title: "Wallet Balance",
                    dataIndex: "balance",
                    key: "balance",
                    render: (val) => <Text>{formatCurrency(val)}</Text>,
                },
                // {
                //     title: "User Status",
                //     dataIndex: "statusName",
                //     key: "statusName",
                //     render: (status) => (
                //         <Text type={status === "Active" ? "success" : "secondary"}>
                //             {status || "-"}
                //         </Text>
                //     ),
                // },
                {
                    title: "Action",
                    key: "action",
                    fixed: "right",
                    render: (_, record) => (
                        <CustomButton
                            type="text"
                            icon={<Image src={EyeIcon} alt="View" preview={false} />}
                            onClick={() => onView(record)}
                        />
                    ),
                },
            ];

        default:
            return [];
    }
};
